import * as Sentry from '@sentry/react';

export function handleException(error) {
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.captureException(error);
  } else {
    console.error(error, error?.stack);
  }
}
